import type { GraphData } from '../types/primitives';
import { appCheckFetch } from './appCheckFetch';

// Graph API uses its own dedicated function
const GRAPH_API_URL = `${import.meta.env['VITE_FUNCTIONS_URL']}apiAdminGraph` || 'http://127.0.0.1:5001/unwritten-memories/us-east1/apiAdminGraph';

/**
 * Fetch graph data from the backend API
 * @param database - 'runtime' or 'design'
 * @returns Graph data with nodes and edges
 */
export async function fetchGraphData(database: 'runtime' | 'design'): Promise<GraphData> {
  try {
    const response = await appCheckFetch(`${GRAPH_API_URL}/graph/${database}`);
    
    if (!response.ok) {
      throw new Error(`Failed to fetch graph data: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching graph data:', error);
    // Return empty graph data on error
    return { nodes: [], edges: [] };
  }
}

/**
 * Legacy function for backward compatibility
 * Returns mock data if backend is unavailable
 */
export function transformToGraphData(mockData: boolean = true): GraphData {
  if (!mockData) {
    return { nodes: [], edges: [] };
  }

  // This is now deprecated - use fetchGraphData instead
  console.warn('transformToGraphData with mock data is deprecated. Use fetchGraphData instead.');
  
  return {
    nodes: [],
    edges: [],
  };
}
